<template>
  <video 
    ref         = "video" 
    crossorigin = "use-credentials"
  >
  </video>
</template>

<script lang="js">

// #region Imports

/* Telestream */
import { ATTACH_VIDEO_ELEMENT } from '@/utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  name: 'VideoPlayer',
  
  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    this.$store.dispatch(ATTACH_VIDEO_ELEMENT, this.$refs.video);
  }

  // #endregion Life-Cycle

};

</script>
